<template>
  <router-view />
  <NotificationToast />
</template>

<script lang="ts" setup>
import { onMounted } from "vue";
import { AuthService } from "./app/services";

onMounted(() => {
  document.title = "GreeZon | Backoffice";
  checkSessionUpdate();
});

const checkSessionUpdate = () => AuthService().updateUserLocalSession();
</script>
